<template>
    <main class="layout">
        <slot/>
    </main>
</template>

<script>
    export default {
        name: 'BaseLayout'
    }
</script>

<style scoped lang="scss">
    @import '../../../scss/variables';

    .layout {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-self: center;
        max-width: 80rem;
        width: 100%;
        padding: 2rem;
        margin-bottom: 4rem;
    }

    @media all and (max-width: 1440px) {
        .layout {
            max-width: 72rem;
        }
    }

    @media all and (max-width: 1200px) {
        .layout {
            max-width: 100%;
            padding: 1rem;
        }
    }

    @media all and (max-width: 640px) {
        .layout {
            padding: 0.5rem;
        }
    }
</style>